//Use this class as a model for future services.
//No Custom Repository Class is required 

import { ItemTag, Tag } from "../entities/entities";
import { EntityManager, Repository } from "aurelia-orm";
import { autoinject } from 'aurelia-dependency-injection';

@autoinject()
export class ItemTagService {


	repository: Repository;
	constructor(private entityManager: EntityManager) {
		this.repository = this.entityManager.getRepository(ItemTag);
	}

	//Create an ItemTag out of the tag, or a new tag
	AddNewItemTag(tag: Tag, itemId:number): ItemTag {

		const newItem:ItemTag = this.repository.getNewEntity();
		newItem.itemId = itemId;
		newItem.tagId = tag.id;
		newItem.name = tag.name;

		return newItem;

	}





}